import React from "react";
import PropTypes from "prop-types";
import styles from "./BottomPanel.module.scss";

const BottomPanel = ({ children }) => {
  return <div className={styles.panel}>{children}</div>;
};

BottomPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BottomPanel;
